<template>
  <div class="page-wrapper">
    <div class="flex-wrapper">
      <div class="filter-container">
        <ul class="list-group" style="font-weight: bold;">
          <li class="list-group-item hover-item">Sales</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'product_sales'}" v-on:click="mode = 'product_sales'">Product Sales</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'statement'}" v-on:click="mode = 'statement'">Statement</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'asset'}" v-on:click="mode = 'asset'">Assets</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'profit'}" v-on:click="mode = 'profit'">Profit/Loss</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'performance'}" v-on:click="mode = 'performance'">Performance</li>
          <li class="list-group-item hover-item" v-bind:class="{'report-selected': mode === 'stock_report'}" v-on:click="mode = 'stock_report'">Stock Value Report</li>
        </ul>
      </div>


      <div class="rest-container">
        <div class="container-fluid h-100" v-if="mode === 'asset'">
          <div class="report-header">
            <button class="btn btn-primary" v-on:click="getAssetReport">Get Asset Report</button>
            <button v-if="assetReport != false" class="btn btn-success" v-on:click="downloadAssetStatement('xlsx')"><i class="fas fa-file-excel"></i> EXCEL</button>
            <button v-if="assetReport != false" class="btn btn-success" v-on:click="downloadAssetStatement('pdf')"><i class="fas fa-file-pdf"></i> PDF</button>
          </div>
          <div class="report-panel-fixed">
            <div>
              <table class="table">
                <tr class="sticky-header-row">
                  <th class="text-left">Category</th>
                  <th class="text-right">Quantity</th>
                  <th class="text-right">Total</th>

                </tr>
                <tbody v-if="assetReport != false">
                <tr v-for="c in assetReport.list" class="hover-item" v-on:click="assetReportCategory = JSON.parse(JSON.stringify(c))" v-bind:class="{'row-item-selected':assetReportCategory != false && c.title === assetReportCategory.title}">
                  <td class="text-left">{{c.title}}</td>
                  <td class="text-right">{{c.amount}}</td>
                  <td class="text-right">{{thousandSeprator((c.totalPrice/100.0).toFixed(2))}}</td>

                </tr>

<!--                <tr class="summary-row sticky-bottom-row">-->
<!--                  <td class="text-left">GRAND TOTAL</td>-->
<!--                  <td class="text-right">{{thousandSeprator((statementReport.totalPrice/100.0).toFixed(2))}}</td>-->
<!--                  <td class="text-right">{{thousandSeprator((statementReport.tax/100.0).toFixed(2))}}</td>-->
<!--                  <td class="text-right">{{thousandSeprator((statementReport.finalDue/100.0).toFixed(2))}}</td>-->
<!--                  <td class="text-right">{{thousandSeprator((statementReport.paid/100.0).toFixed(2))}}</td>-->
<!--                  <td class="text-right">{{thousandSeprator(((statementReport.finalDue - statementReport.paid)/100.0).toFixed(2))}}</td>-->
<!--                </tr>-->
                </tbody>
                <tr class="">
                  <th class="text-left">Total</th>
                  <th class="text-right"></th>
                  <th class="text-right">{{thousandSeprator((assetReport.totalPrice/100.0).toFixed(2))}}</th>

                </tr>
              </table>
            </div>
            <div>
              <table class="table">
                <tr class="sticky-header-row">
                  <th class="text-left">Code</th>
                  <th class="text-left">Item</th>
                  <th class="text-left">Type</th>
                  <!--                  <th>DN</th>-->
                  <th class="text-right">Unit Price</th>
                  <th class="text-right">Qty</th>
                  <th class="text-right">TOTAL</th>
                </tr>
                <tbody>
                <tr v-for="p in assetReportCategory.list">
                  <!--                  <td>{{order.id}}</td>-->

                  <td class="text-left">{{p.code}}</td>
                  <td class="text-left">{{p.title}}</td>
                  <td class="text-left">{{p.stockType}}</td>
                  <td class="text-right">{{thousandSeprator((p.unitPrice/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{p.amount}}</td>
                  <td class="text-right">{{thousandSeprator((p.totalPrice/100.0).toFixed(2))}}</td>
                </tr>
                </tbody>

                <tbody v-if="assetReportCategory != false">
                <tr class="summary-row sticky-bottom-row">
                  <td colspan="3" class="text-left">TOTAL</td>

<!--                  <td><button class="btn btn-success" v-on:click="downloadSelectedMerchantStatement(statementSelectectMerchant, 'pdf')"><i class="fas fa-file-pdf"></i> PDF</button></td>-->
                  <td class="text-right">{{thousandSeprator((assetReportCategory.unitPrice/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{assetReportCategory.amount}}</td>
                  <td class="text-right">{{thousandSeprator((assetReportCategory.totalPrice/100.0).toFixed(2))}}</td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>


        </div>
        <div class="container-fluid h-100" v-else-if="mode === 'statement' || mode === 'profit'">
          <div class="report-header">
            <date-picker v-model="dateRange"  valueType="format" @change="dateRangeSelected" range></date-picker>
            <button class="btn btn-dark" v-on:click="showStatementMerchantSelector = true">Select Shops</button>
<!--            <select v-model="statementMerchantId">-->
<!--              <option value="0">Select Shop</option>-->
<!--              <option v-for="m in merchants" :value="m.id">{{m.title}}</option>-->
<!--            </select>-->
            <select v-model="statementOrder">
              <option value="deliveredTime">Delivered Date</option>
              <option value="invoiceDate">Invoice Date</option>
            </select>
            <select v-model="statementPayment">
              <option value="all">All</option>
              <option value="unpaid">Unpaid</option>
              <option value="paid">Paid</option>
            </select>
            <button class="btn btn-primary" v-on:click="getStatementReport">Get</button>
            <button v-if="statementReport != false" class="btn btn-success" v-on:click="downloadStatement('xlsx')"><i class="fas fa-file-excel"></i> EXCEL</button>
            <button v-if="statementReport != false" class="btn btn-success" v-on:click="downloadStatement('pdf')"><i class="fas fa-file-pdf"></i> PDF</button>
<!--            <span class="toggle-btn" :class="{'enabled': showCost == true}" @click="showCost = !showCost">원가</span>-->
          </div>
          <div class="report-panel-fixed">
            <div>
              <table class="table">
                <tr class="sticky-header-row">
                  <th class="text-left">Shop</th>

                  <th>NET</th>
                  <th>VAT</th>
                  <th>Total</th>
                  <th>Payment</th>
                  <th>Balance</th>
                  <th v-if="mode === 'profit'">Prime Cost</th>
                  <th v-if="mode === 'profit'">Prime Cost VAT</th>
                </tr>
                <tbody v-if="statementReport != false">
                  <tr v-for="m in statementReport.list" class="hover-item" v-on:click="statementSelectectMerchant = JSON.parse(JSON.stringify(m))" v-bind:class="{'row-item-selected':statementSelectectMerchant != false && m.merchantId === statementSelectectMerchant.merchantId}">
                    <td class="text-left">{{m.title}}</td>

                    <td class="text-right">{{thousandSeprator((m.totalPrice/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((m.tax/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((m.finalDue/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((m.paid/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator(((m.finalDue - m.paid)/100.0).toFixed(2))}}</td>
                    <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((m.originalTotal/100.0).toFixed(2))}}</td>
                    <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((m.originalTotalTax/100.0).toFixed(2))}}</td>
                  </tr>

                  <tr class="summary-row sticky-bottom-row">
                    <td class="text-left">GRAND TOTAL</td>

                    <td class="text-right">{{thousandSeprator((statementReport.totalPrice/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((statementReport.tax/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((statementReport.finalDue/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator((statementReport.paid/100.0).toFixed(2))}}</td>
                    <td class="text-right">{{thousandSeprator(((statementReport.finalDue - statementReport.paid)/100.0).toFixed(2))}}</td>
                    <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((statementReport.originalTotal/100.0).toFixed(2))}}</td>
                    <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((statementReport.originalTotalTax/100.0).toFixed(2))}}</td>
                  </tr>
                </tbody>
              </table>
              <div style="width: 100%; text-align:right;">
                <button v-if="statementReport != false" class="btn btn-success" v-on:click="downloadStatement('pdf', true)"><i class="fas fa-file-pdf"></i> SHORT SUMMARY PDF</button>
              </div>
            </div>
            <div>
              <table class="table">
                <tr class="sticky-header-row">
<!--                  <th></th>-->
                  <th>Date</th>
<!--                  <th>Type</th>-->
<!--                  <th>Delivered Date</th>-->
                  <th>INV</th>
<!--                  <th>DN</th>-->
                  <th class="text-right">NET</th>
                  <th class="text-right">VAT</th>
                  <th class="text-right">TOTAL</th>

                  <th class="text-right">Payment</th>
                  <th class="text-right">Balance</th>
                  <th v-if="mode === 'profit'" class="text-right">Prime Cost</th>
                  <th v-if="mode === 'profit'" class="text-right">Prime Cost VAT</th>
                </tr>
                <tbody>
                <tr v-for="order in statementSelectectMerchant.orders" :class="order.orderType + '-row ' + order.type +'-row'">
<!--                  <td>{{order.id}}</td>-->

                  <td>{{order.reportDate}}</td>
<!--                  <td>{{order.orderType}}</td>-->
<!--                  <td><span v-if="order.deliveredTime > 0">{{getDateString(order.deliveredTime)}}</span></td>-->
                  <td><span v-if="order.type !== 'summary' && order.invoice != null" class="clickable" style="padding:10px;" v-on:click="openInvoiceView(order)">{{order.invoice.title}}</span></td>
<!--                  <td><span v-if="order.type !== 'summary' && order.deliveryNotes != null && order.deliveryNotes.length > 0"><i class="fas fa-file-alt"></i></span></td>-->
                  <td class="text-right"><span v-if="order.orderType === 'credit'">-</span>{{thousandSeprator((order.totalPrice/100.0).toFixed(2))}}</td>
                  <td class="text-right"><span v-if="order.orderType === 'credit'">-</span>{{thousandSeprator((order.tax/100.0).toFixed(2))}}</td>
                  <td class="text-right">
                    <span v-if="order.orderType === 'credit'">-{{thousandSeprator((order.finalDue/100.0).toFixed(2))}}</span>
                    <span v-else-if="order.orderType==='sales' || order.type === 'summary'">{{thousandSeprator((order.finalDue/100.0).toFixed(2))}}</span>
                  </td>

                  <td class="text-right">
                    <span >{{thousandSeprator((order.paid/100.0).toFixed(2))}}</span>

                  </td>
                  <td class="text-right"><span v-if="order.orderType === 'sales'">{{thousandSeprator(((order.finalDue-order.paid)/100.0).toFixed(2))}}</span><span v-else>0.00</span></td>
                  <td v-if="mode === 'profit'" class="text-right">
                    <span >{{thousandSeprator((order.originalPrice/100.0).toFixed(2))}}</span>

                  </td>
                  <td v-if="mode === 'profit'" class="text-right">
                    <span >{{thousandSeprator((order.originalTax/100.0).toFixed(2))}}</span>

                  </td>
                </tr>
                </tbody>

                <tbody v-if="statementSelectectMerchant != false">
                <tr class="summary-row sticky-bottom-row">
                  <td class="text-left">TOTAL</td>
                  <td><button class="btn btn-success" v-on:click="downloadSelectedMerchantStatement(statementSelectectMerchant, 'pdf')"><i class="fas fa-file-pdf"></i> PDF</button></td>
                  <td class="text-right">{{thousandSeprator((statementSelectectMerchant.totalPrice/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{thousandSeprator((statementSelectectMerchant.tax/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{thousandSeprator((statementSelectectMerchant.finalDue/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{thousandSeprator((statementSelectectMerchant.paid/100.0).toFixed(2))}}</td>
                  <td class="text-right">{{thousandSeprator(((statementSelectectMerchant.finalDue - statementSelectectMerchant.paid)/100.0).toFixed(2))}}</td>
                  <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((statementSelectectMerchant.originalTotal/100.0).toFixed(2))}}</td>
                  <td v-if="mode === 'profit'" class="text-right">{{thousandSeprator((statementSelectectMerchant.originalTotalTax/100.0).toFixed(2))}}</td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>


        </div>
        <div class="container-fluid h-100" v-else-if="mode === 'product_sales'" v-on:click="backgroundClick">
          <div class="report-header">
            <date-picker v-model="dateRange" valueType="format" @change="dateRangeSelected" range></date-picker>


            <button class="btn btn-dark" v-on:click="showProductSelector = true">Select Items</button>
            <button class="btn btn-success" v-on:click="showProductSalesMerchantSelector = true">Shops {{productSalesMerchants.length}} Selected</button>
            <button class="btn btn-primary" v-on:click="getStatementItemReport">Get</button>
            <button class="btn btn-success" v-if="itemReports != false" style="margin-left:20px;" v-on:click="downloadStatementItemReport('pdf')">PDF</button>
            <button class="btn btn-success" v-if="itemReports != false" style="margin-left:20px;" v-on:click="downloadStatementItemReport('xlsx')">Excel</button>
            <button v-if="selectedProducts.length > 0" class="btn btn-danger" style="margin-left:100px;" v-on:click="selectedProducts = []">Clear All</button>

          </div>
          <div class="report-panel-fixed">
            <div>
              <table class="table">
                <tr class="sticky-header-row">
                  <th class="text-left">Item <span v-if="selectedProducts.length > 0" style="float:right;" v-on:click="selectedProducts = []"><i class="fas fa-times"></i> Clear</span></th>
                  <th>Qty</th>
                  <th>Weight</th>
                  <th class="text-right">NET</th>
                  <th class="text-right">VAT</th>
                  <th class="text-right">GROSS</th>

                </tr>

                <template v-if="itemReports != false">
                  <tbody  v-for="(p, pi) in itemReports.list">
<!--                  <tr  v-for="(m, mi) in p.merchants" :class="'section-' + pi%5" v-on:click="selectedProductReport = p">-->
                  <tr @click="selectProductReport(p)" class="hover-item"
                      v-bind:class="{'report-selected':selectedProductReport != false && p.productId == selectedProductReport.id, 'deleted-item':p.deleted === true}"
                      v-on:click="selectedProductReport = p">
                    <td class="text-left"><strong>{{p.title}}</strong> <span v-if="p.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span></td>
                    <td><strong>{{p.amount}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((p.variablePriceAmount/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((p.totalPrice/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((p.tax/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((p.finalDue/100.0).toFixed(2))}}</strong></td>
                  </tr>
                  </tbody>
                  <tr class="summary-row sticky-bottom-row">
                    <td class="text-right"><button class="btn btn-success" @click="downloadSummaryStatementItemReport">PDF</button> Total</td>
                    <td><strong>{{itemReports.amount}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((itemReports.variablePriceAmount/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((itemReports.totalPrice/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((itemReports.tax/100.0).toFixed(2))}}</strong></td>
                    <td class="text-right"><strong>{{thousandSeprator((itemReports.finalDue/100.0).toFixed(2))}}</strong></td>
                  </tr>
                </template>
                <template v-else-if="selectedProducts.length > 0">
                  <tr v-for="p in selectedProducts">
                    <td class="text-left" v-bind:class="{'deleted-item':p.deleted === true}">
                      <strong>{{p.title}}</strong>
                      <span v-if="p.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span>
                    </td>
                    <td/>
                    <td/>
                    <td/>
                    <td/>
                    <td/>

                  </tr>
                </template>
              </table>
            </div>
            <div>
              <transition name="slideup">
              <table class="table" v-if="selectedProductReport != false">
                <tr class="sticky-header-row">
                  <th class="text-left">Shop</th>
                  <!--                <th>Ordered Qty</th>-->
                  <th>Qty</th>
                  <th>Weight</th>
                  <th class="text-right">NET</th>
                  <th class="text-right">VAT</th>
                  <th class="text-right">GROSS</th>
                </tr>
                <tr  v-for="(m, mi) in selectedProductReport.list" v-if="m.orders != null && m.orders.length > 0">

                  <td class="text-left left-section-border">{{m.title}}</td>
                  <!--                  <td><span v-if="m.orderedAmount != undefined">{{m.orderedAmount}}</span></td>-->
                  <td><span v-if="m.amount != undefined">{{m.amount}}</span></td>
                  <td class="text-right"><span v-if="m.totalPrice != undefined">{{thousandSeprator((m.variablePriceAmount/100.0).toFixed(2))}}</span></td>
                  <td class="text-right"><span v-if="m.totalPrice != undefined">{{thousandSeprator((m.totalPrice/100.0).toFixed(2))}}</span></td>
                  <td class="text-right"><span v-if="m.tax != undefined">{{thousandSeprator((m.tax/100.0).toFixed(2))}}</span></td>
                  <td class="text-right"><span v-if="m.finalDue != undefined">{{thousandSeprator((m.finalDue/100.0).toFixed(2))}}</span></td>
                </tr>
                <tr class="summary-row sticky-bottom-row">
                  <td class="text-right">Total</td>
                  <td><strong>{{selectedProductReport.amount}}</strong></td>
                  <td class="text-right"><strong>{{thousandSeprator((selectedProductReport.variablePriceAmount/100.0).toFixed(2))}}</strong></td>
                  <td class="text-right"><strong>{{thousandSeprator((selectedProductReport.totalPrice/100.0).toFixed(2))}}</strong></td>
                  <td class="text-right"><strong>{{thousandSeprator((selectedProductReport.tax/100.0).toFixed(2))}}</strong></td>
                  <td class="text-right"><strong>{{thousandSeprator((selectedProductReport.finalDue/100.0).toFixed(2))}}</strong></td>
                </tr>
              </table>
              </transition>
            </div>
          </div>
        </div>
        <div class="container-fluid h-100" v-else-if="mode === 'performance'" v-on:click="backgroundClick">
          <div class="report-header">
            <date-picker v-model="performanceDateRange" valueType="format" @change="performanceDateRangeSelected" range></date-picker>

<!--            <select v-model="performanceMerchantId">-->
<!--              <option value="0">Select Shop</option>-->
<!--              <option v-for="m in merchants" :value="m.id">{{m.title}}</option>-->
<!--            </select>-->
            <button class="btn btn-success" v-on:click="showPerformanceMerchantSelector = true">Shops {{performanceMerchants.length}} Selected</button>
            <button class="btn btn-primary" v-on:click="getPerformance">Get</button>
            <button class="btn btn-success" v-if="performanceReport != false" v-on:click="exportPerformance('xlsx', false)"><i class="fas fa-file-excel"></i> 요약 엑셀</button>
            <button class="btn btn-success" v-if="performanceReport != false" v-on:click="exportPerformance('xlsx', true)"><i class="fas fa-file-excel"></i> 매장 데이터포함 엑셀</button>
          </div>
          <div class="report-panel-fixed">
            <div style="width: 100%;" v-if="performanceReport != false">
              <table class="table text-right data-table">
                <tr class="sticky-header-row">
                  <th class="text-left">Category</th>
                  <th class="text-left">Product <span style="float:right; height:25px; line-height: 25px; padding-left: 10px; padding-right: 10px;" v-on:click="performanceReportFilter = ''"><i class="fas fa-times"/></span><input type="text" v-model="performanceReportFilter" style="width:calc(100% - 200px); float: right;" placeholder="Filter search"/></th>
                  <th>Quantity</th>
                  <th>Weight</th>
                  <th>NET</th>
                  <th>VAT</th>
                  <th>GROSS</th>
                  <template v-if="performanceReport.cols != null && performanceReport.cols.length > 0">
                    <th v-for="col in performanceReport.cols">
                      {{col}}
                    </th>
                  </template>
                </tr>
                <template v-for="item in performanceReport.list" v-if="performanceReportFilter == '' || item.title.toLowerCase().includes(performanceReportFilter.toLowerCase())">
                  <tbody >
                  <tr style="font-weight: bold;" class="clickable"
                      data-toggle="collapse" :data-target="'#product-performance-group-' + item.productId" aria-expanded="false" :id="'product-performance-toggle-'+item.productId">
                    <td class="text-left"><span v-if="item.categoryCode !== null && item.categoryCode.length > 0">[{{item.categoryCode}}]</span>{{item.category}}</td>
                    <td class="text-left">{{item.title}} <span><i class="fas fa-chevron-right"></i></span></td>
                    <td><span v-if="item.amount > 0">{{item.amount}}</span></td>
                    <td><span v-if="item.variablePriceAmount > 0">{{thousandSeprator((item.variablePriceAmount/100.0).toFixed(2))}}kg</span></td>
                    <td>{{thousandSeprator((item.totalPrice/100.0).toFixed(2))}}</td>
                    <td>{{thousandSeprator((item.tax/100.0).toFixed(2))}}</td>
                    <td>{{thousandSeprator(((item.totalPrice + item.tax)/100.0).toFixed(2))}}</td>
                    <template v-if="item.list != null && item.list.length > 0">
                      <td v-for="month in item.list">
                        <span v-if="month.variablePriceAmount > 0">{{thousandSeprator((month.variablePriceAmount/100.0).toFixed(2))}}Kg</span>
                        <span v-else>{{month.amount}}</span>
                      </td>
                    </template>
                  </tr>
                  </tbody>
                  <tbody v-bind:id="'product-performance-group-'+item.productId" class="collapse" :aria-labelledby="'product-performance-toggle-'+item.productId">
                  <tr v-for="merchant in item.merchantReports">
                    <td></td>
                    <td class="text-right">{{merchant.title}}</td>
                    <td><span v-if="merchant.amount > 0">{{merchant.amount}}</span></td>
                    <td><span v-if="merchant.variablePriceAmount > 0">{{thousandSeprator((merchant.variablePriceAmount/100.0).toFixed(2))}}Kg</span></td>
                    <td>{{thousandSeprator((merchant.totalPrice/100.0).toFixed(2))}}</td>
                    <td>{{thousandSeprator((merchant.tax/100.0).toFixed(2))}}</td>
                    <td>{{thousandSeprator(((merchant.totalPrice + item.tax)/100.0).toFixed(2))}}</td>
                    <template v-if="merchant.list != null && merchant.list.length > 0">
                      <td v-for="month in merchant.list">

                        <span v-if="month.variablePriceAmount > 0">{{thousandSeprator((month.variablePriceAmount/100.0).toFixed(2))}}Kg</span>
                        <span v-else>{{month.amount}}</span>
                      </td>
                    </template>
                  </tr>
                  </tbody>

                </template>
                <tbody>
                <tr class="sticky-bottom-row" style="background-color: #D7D7D7; font-weight: bold;">
                  <td colspan="2" class="text-right">Total</td>
<!--                  <td><span v-if="performanceReport.amount > 0">{{performanceReport.amount}}</span></td>-->
<!--                  <td><span v-if="performanceReport.weight > 0">{{thousandSeprator((performanceReport.weight/100.0).toFixed(2))}}Kg</span></td>-->
                  <td/><td/>
                  <td>{{thousandSeprator((performanceReport.totalPrice/100.0).toFixed(2))}}</td>
                  <td>{{thousandSeprator((performanceReport.tax/100.0).toFixed(2))}}</td>
                  <td>{{thousandSeprator(((performanceReport.totalPrice + performanceReport.tax)/100.0).toFixed(2))}}</td>
                  <template v-if="performanceReport.breakdownList != null && performanceReport.breakdownList.length > 0">

                    <td v-for="month in performanceReport.breakdownList">
<!--                      <span v-if="month.amount > 0">{{month.amount}}</span>-->
<!--                      <span v-else-if="month.weight > 0">{{thousandSeprator((month.weight/100.0).toFixed(2))}}Kg</span>-->
                    </td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="container-fluid h-100" v-else-if="mode === 'stock_report'" v-on:click="backgroundClick">
          <div class="report-header">

            <button class="btn btn-success" v-on:click="getStockAssetReport('xlsx')">Get Report of Now</button>

            <date-picker style="margin-left: 20px;" v-model="stockReportDateRange" valueType="format" @change="stockReportDateRangeSelected" range></date-picker>

            <!--            <select v-model="performanceMerchantId">-->
            <!--              <option value="0">Select Shop</option>-->
            <!--              <option v-for="m in merchants" :value="m.id">{{m.title}}</option>-->
            <!--            </select>-->
            <button class="btn btn-primary" v-on:click="getStockReports">Get History</button>
          </div>
          <div class="report-panel-fixed" style="background: white;">
            <div style="width: 100%;" >
              <table class="table text-left data-table">
                <tr class="sticky-header-row">
                  <th>Report Date</th>
                  <th></th>
                </tr>
                <tbody v-for="r in stockReports">
                <tr>
                  <td>
                    {{r.title}}
                  </td>
                  <td>
                    <button class="btn btn-success" @click="downloadStockReport(r)"><i class="fas fa-download"> Download</i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slideup">
      <div class="item-container" v-if="merchantProductReport != false" v-on:click="merchantProductReport = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:900px; height:100%; padding-top:10px; overflow-y: auto; position: relative;">
            <table class="table" style="width:calc(100% - 20px); margin:auto;" v-if="merchantProductReport.list.length > 0">
              <tr class="sticky-header-row text-left">
                <th>Date</th>
                <!--                <th>Type</th>-->
                <!--                <th>Delivered Date</th>-->
                <th>INV</th>
                <th class="text-center">Order Qty</th>
                <th class="text-center">Qty</th>
                <!--                <th>DN</th>-->
                <th class="text-right">NET</th>
                <th class="text-right">VAT</th>
                <th class="text-right">TOTAL</th>
                <!--                <th class="text-right">Payment</th>-->
                <!--                <th class="text-right">Remaining</th>-->
              </tr>
              <tbody>
              <tr v-for="order in merchantProductReport.list" class="text-left" :class="order.orderType + '-row ' + order.type +'-row'">

                <td>{{order.reportDate}}</td>
                <td class="text-left"><span v-if="order.invoice != null" class="clickable" style="padding:10px;" v-on:click="openInvoiceView(order)">{{order.invoice.title}}</span></td>
                <td class="text-center">{{order.orderedAmount}}</td>
                <td class="text-center">{{order.amount}}</td>
                <!--                <td>{{order.orderType}}</td>-->
                <!--                <td><span v-if="order.deliveredTime > 0">{{getDateString(order.deliveredTime)}}</span></td>-->

                <!--                <td><span v-if="order.type !== 'summary' && order.deliveryNotes != null && order.deliveryNotes.length > 0"><i class="fas fa-file-alt"></i></span></td>-->
                <td class="text-right"><span v-if="order.orderType === 'credit'">-</span>{{(order.totalPrice/100.0).toFixed(2)}}</td>
                <td class="text-right"><span v-if="order.orderType === 'credit'">-</span>{{(order.tax/100.0).toFixed(2)}}</td>
                <td class="text-right"><span v-if="order.orderType==='sales' || order.type === 'summary'">{{(order.finalDue/100.0).toFixed(2)}}</span></td>
                <!--                <td class="text-right">-->
                <!--                  <span v-if="order.orderType === 'sales' || order.type === 'summary'">{{(order.paid/100.0).toFixed(2)}}</span>-->
                <!--                  <span v-else-if="order.orderType === 'credit'">CR {{(order.finalDue/100.0).toFixed(2)}}</span>-->
                <!--                </td>-->
                <!--                <td class="text-right"><span v-if="order.orderType === 'sales'">{{((order.finalDue-order.paid)/100.0).toFixed(2)}}</span><span v-else>0.00</span></td>-->
              </tr>
              </tbody>
            </table>
          </div>
          <div style="width:calc(100% - 900px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h4>{{merchantProductReport.product}}</h4>
            <hr>
            <h5>{{merchantProductReport.title}}</h5>
            <h6>{{merchantProductReport.dates}}</h6>
            <table class="text-left">
              <tr>
                <td style="padding-right:20px;">Ordered Amount </td>
                <td class="text-right">{{merchantProductReport.orderedAmount}}</td>
              </tr>
              <tr>
                <td>Amount </td>
                <td class="text-right">{{merchantProductReport.amount}}</td>
              </tr>
              <tr>
                <td>NET </td>
                <td class="text-right">{{(merchantProductReport.net/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>VAT </td>
                <td class="text-right">{{(merchantProductReport.vat/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>GROSS </td>
                <td class="text-right">{{(merchantProductReport.gross/100.0).toFixed(2)}}</td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="statementPdfView != false" v-on:click="statementPdfView = false">
        <div style="position: absolute; width: 100%; height: 100%; top: 0; left:0; background-color: white;" v-on:click.stop="dummy">
          <div style="width: 100%; height: 60px; display: flex;">
            <div style="height: 60px; line-height: 60px; width: 80px; font-size: 40px; text-align: center;">
              <i class="fas fa-file-invoice"></i>
            </div>
            <div style="height: 60px;">
              <div style="height: 35px; line-height: 35px; font-size: 20px; padding-left: 20px; font-weight: bold;">
                STATEMENT PDF
              </div>
              <div style="height: 25px; padding-left: 20px; text-align: left; font-size: 16px; color: #666; font-weight: bold;">
                {{statementPdfView.dateFrom}}<span v-if="statementPdfView.dateTo != null && statementPdfView.dateTo.length > 0"> ~ {{statementPdfView.dateTo}}</span>
              </div>
            </div>
            <div style="padding-left: 40px; line-height: 60px;">
              <button v-if="statementPdfView.merchant != undefined" class="form-control btn btn-primary" v-on:click="sendStatementDocument(statementPdfView)">SEND EMAIL</button>
            </div>
            <div style="margin-left: auto;">

              <div style="width: 60px; height: 60px; line-height: 60px; font-size: 30px; margin-right: 30px;" v-on:click="statementPdfView = false">
                <i class="fas fa-times" style="color:black;"></i>
              </div>
            </div>
          </div>
          <div style="width:100%; height:calc(100% - 60px);">
            <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + statementPdfView.filePath" style="width: 100%; height: 100%; margin:auto"/>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="showProductSelector == true" v-on:click="showProductSelector = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-3" style="height:50px;line-height: 50px; padding-top:8px;">
                  <select class="form-control" v-model="selectedCat" @change="categorySelected">
                    <option value="0">All</option>
                    <option v-for="cat in categories" :value="cat.id">{{cat.title}}</option>
                  </select>
                </div>
                <div class="col-6 text-left" style="height:50px;line-height: 50px;display: flex; position:relative;padding-top:8px;">
                  <input type="text" class="form-control" id="product-candidate-search-input" v-model="productSearchWord" v-on:keyup="search" style="width: calc(100% - 50px)" placeholder="Search Product"/>
                  <span style="height: 30px; line-height: 30px; padding-left:10px;" v-on:click="initialiseSearch"><i class="fas fa-times"></i></span>
                </div>
                <div class="col-3 text-right" style="height:50px;line-height: 50px;">
                  <button class="btn btn-primary" v-on:click="addAllCandidate">Add All</button>
<!--                  <button class="btn btn-primary" v-on:click="selectStatementMerchantByType('kokoro')">KOKOR</button>-->
<!--                  <button class="btn btn-danger" v-on:click="selectStatementMerchantByType('jv')">JV</button>-->
<!--                  <button class="btn btn-success" v-on:click="selectStatementMerchantByType('franchise')">Franchise</button>-->
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
              <div class="row h-100">
                <div class="col-12 h-100">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item"  v-for="(m, index) in candidates" :tabindex="index" :id="'product-candidate-'+ index"  :key="'candidate-' + m.id" v-on:keyup="moveFocusOnCandidate($event, m)" v-on:click="selectCandidate(m)" v-if="isOnSelectedProductList(m) == false" v-bind:class="{'deleted-item':m.deleted === true}">
                      {{m.title}} <span v-if="m.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-6 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Selected Item List
                </div>
                <div class="col-6 text-right" style="height:50px;line-height: 50px;">
                  <button class="btn btn-danger" v-on:click="selectedProducts = []"><i class="fas fa-times" style="color:white;"></i> Clear</button>
                  <button class="btn btn-dark" style="margin-left:20px;" v-on:click="showProductSelector = false">Done</button>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
              <div class="row">
                <div class="col-12">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item" v-for="(p, index) in selectedProducts" :key="'selected-product-'+ p.id" v-on:click="selectedProducts.splice(index, 1)" v-bind:class="{'deleted-item':p.deleted === true}">
                      {{p.title}} <span v-if="p.deleted === true">&nbsp;&nbsp; <strong>DELETED</strong></span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="showStatementMerchantSelector == true" v-on:click="showStatementMerchantSelector = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-4 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Shop List
                </div>
                <div class="col-8 text-right" style="height:50px;padding-top:10px;">
                  <button class="btn btn-dark" v-on:click="selectStatementMerchantByType('all')">All</button>
                  <button class="btn btn-primary" v-on:click="selectStatementMerchantByType('kokoro')">KOKORO</button>
                  <button class="btn btn-danger" v-on:click="selectStatementMerchantByType('jv')">JV</button>
                  <button class="btn btn-success" v-on:click="selectStatementMerchantByType('franchise')">Franchise</button>
                  <button class="btn btn-primary" v-on:click="selectStatementMerchantByType('premier')">Premier</button>
                  <button class="btn btn-danger" v-on:click="selectStatementMerchantByType('vendor')">VENDOR</button>
                  <button class="btn btn-success" v-on:click="selectStatementMerchantByType('personal')">Personal</button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input v-model="merchantSearch"/><span @click="merchantSearch = ''">Clear</span>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 100px); overflow-y: auto;">
              <div class="row h-100">
                <div class="col-12 h-100">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item"  v-for="m in merchants" :key="'candidate-' + m.id"
                        :class="{'deactivated': m.active === false}"
                        v-on:click="addStatementMerchant(m)"
                        v-if="isOnStatementMerchantsList(m) == false && (merchantSearch === '' || m.title.toLowerCase().includes(merchantSearch.toLowerCase()))">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-6 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Selected Shop List
                </div>
                <div class="col-6 text-right" style="height:50px;line-height: 50px;">
                  <button class="btn btn-danger" v-on:click="statementMerchants = []"><i class="fas fa-times" style="color:white;"></i> Clear</button>
                  <button class="btn btn-dark" style="margin-left:20px;" v-on:click="showStatementMerchantSelector = false">Done</button>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
              <div class="row">
                <div class="col-12">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item" v-for="(m, index) in statementMerchants" :key="'selected-'+ m.id" v-on:click="statementMerchants.splice(index, 1)">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="showProductSalesMerchantSelector == true" v-on:click="showProductSalesMerchantSelector = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-4 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Shop List
                </div>
                <div class="col-8 text-right" style="height:50px;padding-top:10px;">
                  <button class="btn btn-dark" v-on:click="selectProductSalesMerchantByType('all')">All</button>
                  <button class="btn btn-primary" v-on:click="selectProductSalesMerchantByType('kokoro')">KOKORO</button>
                  <button class="btn btn-danger" v-on:click="selectProductSalesMerchantByType('jv')">JV</button>
                  <button class="btn btn-success" v-on:click="selectProductSalesMerchantByType('franchise')">Franchise</button>
                  <button class="btn btn-primary" v-on:click="selectProductSalesMerchantByType('premier')">Premier</button>
                  <button class="btn btn-danger" v-on:click="selectProductSalesMerchantByType('vendor')">Vendor</button>
                  <button class="btn btn-success" v-on:click="selectProductSalesMerchantByType('personal')">Personal</button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input v-model="merchantSearch"/><span @click="merchantSearch = ''">Clear</span>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 100px); overflow-y: auto;">
              <div class="row h-100">
                <div class="col-12 h-100">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item"
                        v-for="m in merchants" :key="'candidate-' + m.id"
                        :class="{'deactivated': m.active === false}"
                        v-on:click="addProductSalesMerchant(m)"
                        v-if="isOnProductSalesMerchantsList(m) == false && (merchantSearch === '' || m.title.toLowerCase().includes(merchantSearch.toLowerCase()))">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-6 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Selected Shop List
                </div>
                <div class="col-6 text-right" style="height:50px;line-height: 50px;">
                  <button class="btn btn-danger" v-on:click="productSalesMerchants = []"><i class="fas fa-times" style="color:white;"></i> Clear</button>
                  <button class="btn btn-dark" style="margin-left:20px;" v-on:click="showProductSalesMerchantSelector = false">Done</button>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
              <div class="row">
                <div class="col-12">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item" v-for="(m, index) in productSalesMerchants" :key="'selected-'+ m.id" v-on:click="productSalesMerchants.splice(index, 1)">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="showPerformanceMerchantSelector == true" v-on:click="showPerformanceMerchantSelector = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-2 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Shops
                </div>
                <div class="col-10 text-right" style="height:50px;padding-top:10px;">
                  <button class="btn btn-dark" v-on:click="selectPerformanceMerchantByType('all')">All</button>
                  <button class="btn btn-primary" v-on:click="selectPerformanceMerchantByType('kokoro')">KOKORO</button>
                  <button class="btn btn-danger" v-on:click="selectPerformanceMerchantByType('jv')">JV</button>
                  <button class="btn btn-success" v-on:click="selectPerformanceMerchantByType('franchise')">Franchise</button>
                  <button class="btn btn-primary" v-on:click="selectPerformanceMerchantByType('premier')">Premier</button>
                  <button class="btn btn-danger" v-on:click="selectPerformanceMerchantByType('vendor')">Vendor</button>
                  <button class="btn btn-success" v-on:click="selectPerformanceMerchantByType('personal')">Personal</button>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <input v-model="merchantSearch"/><span @click="merchantSearch = ''">Clear</span>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 100px); overflow-y: auto;">
              <div class="row h-100">
                <div class="col-12 h-100">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item"  v-for="m in merchants" :key="'candidate-' + m.id"
                        v-on:click="addPerformanceMerchant(m)"
                        :class="{'deactivated': m.active === false}"
                        v-if="isOnPerformanceMerchantsList(m) == false && (merchantSearch === '' || m.title.toLowerCase().includes(merchantSearch.toLowerCase()))">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 50%; height: 100%">
            <div class="container">
              <div class="row">
                <div class="col-6 text-left" style="height:50px;line-height: 50px; font-size: 25px;font-weight: bold;">
                  Selected Shop List
                </div>
                <div class="col-6 text-right" style="height:50px;line-height: 50px;">
                  <button class="btn btn-danger" v-on:click="performanceMerchants = []"><i class="fas fa-times" style="color:white;"></i> Clear</button>
                  <button class="btn btn-dark" style="margin-left:20px;" v-on:click="showPerformanceMerchantSelector = false">Done</button>
                </div>
              </div>
            </div>
            <div class="container" style="height: calc(100% - 50px); overflow-y: auto;">
              <div class="row">
                <div class="col-12">
                  <transition-group name="list" tag="ul">
                    <li class="list-group-item text-left hover-item" v-for="(m, index) in performanceMerchants" :key="'selected-'+ m.id" v-on:click="performanceMerchants.splice(index, 1)">
                      [{{m.type.toUpperCase()}}]{{m.title}} {{m.companyName}} <span v-if="m.active === false"> (Deactivated)</span>
                    </li>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="invoiceView != false" v-on:click="closeInvoiceView()">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:800px; height:100%; padding-top:10px;">
            <embed :src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + invoiceView.invoice.description" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
          </div>
          <div style="width:calc(100% - 800px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h5>{{getMerchantName(invoiceView.merchantId)}}</h5>
            <h6>Order Number: {{invoiceView.id}}</h6>
            <h6>Invoice Number: {{invoiceView.invoice.title}}</h6>
            <br>
            <br>
            <h6>NET: £{{(invoiceView.totalPrice/100.0).toFixed(2)}}</h6>
            <h6>TAX: £{{(invoiceView.tax/100.0).toFixed(2)}}</h6>
            <h6>GROSS: £{{(invoiceView.finalDue/100.0).toFixed(2)}}</h6>

            <br>
            <br>
            <h6>Delivery Date: {{invoiceView.deliveryDate}}</h6>
            <br>
            <br>
<!--            <button class="form-control btn btn-dark" v-on:click="regenerateInvoice(invoiceView.id)">REGENERATE INVOICE</button>-->
<!--            <br>-->
<!--            <br>-->
<!--            <button class="form-control btn btn-primary" v-on:click="sendInvoice(invoiceView.id)">SEND INVOICE</button>-->

<!--            <table style="width: 100%; margin-top:20px;">-->
<!--              <tr>-->
<!--                <td style="vertical-align: top; vertical-align: top;">-->
<!--                  Email to:-->
<!--                </td>-->
<!--                <td style="text-align: left; vertical-align: top;">-->
<!--                  <div v-html="getMerchantEmailList(invoiceView.merchantId)"/>-->
<!--                </td>-->

<!--              </tr>-->

<!--            </table>-->


          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  assetStatement,
  assetStatementExcel,
  assetStatementPDF,
  getCategories, getDocuments, getProductsByCategory, searchAllProducts,
  searchProducts,
  stockQuery, stockValueReportExcel
} from '../api/product'
    import {queryVisits} from "../api/report";
  import {
    getOrder, getOrderItemSummaryExcel, getOrderItemSummaryPDF,
    getOrderReport,
    getOrderStatementExcel,
    getOrderStatementPDF, getPerformanceStatementExcel, queryMerchantPerformance, queryOrderItemStatement,
    queryOrders,
    queryOrderStatement, sendOrderStatementPDF
  } from "../api/order";
import {generateOrderNumber, millisToDate, millisToReadable, setLastPage, showDialog} from "../api/utils";
  import {getVendorOrders, getVendors} from "../api/vendors";
  import {getMerchants} from "../api/merchant";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
import FileDownload from "js-file-download";
    export default {
        name: "Report",
        data() {
            return {
                filter: {
                    dateFrom:'',
                    dateTo:'',
                    type:'',
                },
                sales:[],
                salesSummary:false,
                stocks:[],
                stockSummary:false,
                purchaseOrders:[],
                purchaseOrderSummary: false,
                selectedMerchantId:0,
                vendors:[],
                suppliers:[],
                merchants:[],
                itemSalesView:false,


                mode:'',
                dateRange:null,

                stockReportDateRange:null,
                stockReports:[],

                performanceDateRange:null,

                performanceMerchantId:0,
                performanceMerchants: [],
                performanceReport:false,
                performanceReportFilter:'',
                showPerformanceMerchantSelector: false,
                showCost:false,
                statementMerchantId:0,
                statementMerchants:[],

                statementReport: false,
                statementSelectectMerchant: false,
                showStatementMerchantSelector: false,
                statementOrder:'deliveredTime',
                statementItems:[],
                statementPdfView: false,
                statementPayment:'all',

                invoiceView:false,

                assetReport:false,
                assetReportCategory: false,

                showProductSelector: false,
                statementProductItems:[],
                selectedProducts:[],

                merchantProductReport:[],
                statementProductId:0,
                searchProductList:[],
                selectedProductId:0,
                productSearchWord:'',
                candidates:[],
                itemReports: false,
                selectedProductReport:false,

                categories:[],
                selectedCat: 0,

                showProductSalesMerchantSelector: false,
                productSalesMerchants:[],

                merchantSearch:'',

            }
        },
        components: {
          DatePicker,
        },
        created() {
          setLastPage(this.$route.path);
            this.getVendorList();
        },
        mounted() {

        },
        methods: {
            getTimeString:millisToReadable,

            getDateString: function(time) {
              return millisToDate(time, '-');
            },
            updatePage: function() {

            },
            dummy:function() {

            },

            getVendorList: function() {
              let self = this;
              getVendors('vendor')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.vendors = data.item;
                  }
                  self.getSupplierList();
                })
                .catch(function(err) {

                })
            },
            getSupplierList: function() {
              let self = this;
              getVendors('supplier')
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.suppliers = data.item;
                    self.getMerchantList();
                  }
                })
                .catch(function(err) {

                })
            },
            getCategoryList: function() {
              let self = this;
              getCategories()
              .then(function(data) {
                if(data.success == true) {
                  self.$data.categories = data.item;
                }
              })
            },
            getMerchantList: function() {
              let self = this;
              getMerchants()
              .then(function(data) {
                if(data.success == true) {
                  let deactivatedList = [];
                  for(let i = 0 ; i < data.item.length ; i++) {
                    if(data.item[i].active === true) {
                      self.$data.merchants.push(data.item[i]);
                    } else {
                      deactivatedList.push(data.item[i]);
                      console.log(data.item[i].title + ' is ' + data.item[i].active);
                    }
                  }
                  if(deactivatedList.length > 0) {
                    for(let i = 0 ; i < deactivatedList.length ; i++) {
                      self.$data.merchants.push(deactivatedList[i]);
                    }

                  }
                  // self.$data.merchants = data.item;
                  self.getCategoryList();
                }
              })
              .catch(function(err) {

              })
            },
            getMerchantName: function(id) {
              if(this.$data.merchants.length == 0) {
                return '';
              }
              for(let i = 0 ; i < this.$data.merchants.length ; i++) {
                if(this.$data.merchants[i].id == id) {
                  return this.$data.merchants[i].title;
                }
              }
              return 'Unknown(' + id + ')';
            },
            getVendorName: function(id) {
              if(id == 0) {
                return'';
              }
              if(this.$data.vendors.length == 0) {
                return ''
              }
              for(let i = 0 ; i < this.$data.vendors.length ;i++ ) {
                if(this.$data.vendors[i].id == id) {
                  return this.$data.vendors[i].title;
                }
              }
              if(this.$data.suppliers.length == 0) {
                return '';
              }
              for(let i = 0 ; i < this.$data.suppliers.length ;i++ ) {
                if(this.$data.suppliers[i].id == id) {
                  return this.$data.suppliers[i].title;
                }
              }
              return '? ' + id;
            },
            initialiseList: function() {
              this.$data.sales = [];
              this.$data.salesSummary = false;
              this.$data.stocks = [];
              this.$data.stockSummary = false;
              this.$data.purchaseOrders = [];
              this.$data.purchaseOrderSummary = false;
            },
            getItemSales: function() {
                this.$data.itemSalesView = true;
            },
            getItemReport: function() {
                if(this.$data.itemSalesView == false) {
                  return;
                }


            },
            isOnStatementMerchantsList: function(m) {
              for (let i = 0; i < this.$data.statementMerchants.length; i++) {
                if(this.$data.statementMerchants[i].id == m.id) {
                  return true;
                }
              }
              return false;
            },
            selectStatementMerchantByType: function(type) {
              // this.$data.statementMerchants = [];
              for (let i = 0; i < this.$data.merchants.length; i++) {
                if(type === 'all' || this.$data.merchants[i].type === type) {
                  let foundFromSelectedList = false;
                  for(let m = 0 ; m < this.$data.statementMerchants.length ; m++) {
                    if(this.$data.statementMerchants[m].id == this.$data.merchants[i].id) {
                      foundFromSelectedList = true;
                      break;
                    }
                  }
                  if(foundFromSelectedList == false) {
                    this.$data.statementMerchants.push(JSON.parse(JSON.stringify(this.$data.merchants[i])));
                  }
                }
              }
              this.$data.statementMerchants.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })
            },
          isOnProductSalesMerchantsList: function(m) {
            for (let i = 0; i < this.$data.productSalesMerchants.length; i++) {
              if(this.$data.productSalesMerchants[i].id == m.id) {
                return true;
              }
            }
            return false;
          },
            selectProductSalesMerchantByType: function(type) {
              // this.$data.statementMerchants = [];
              for (let i = 0; i < this.$data.merchants.length; i++) {
                if(type === 'all' || this.$data.merchants[i].type === type) {
                  let foundFromSelectedList = false;
                  for(let m = 0 ; m < this.$data.productSalesMerchants.length ; m++) {
                    if(this.$data.productSalesMerchants[m].id == this.$data.merchants[i].id) {
                      foundFromSelectedList = true;
                      break;
                    }
                  }
                  if(foundFromSelectedList == false) {
                    this.$data.productSalesMerchants.push(JSON.parse(JSON.stringify(this.$data.merchants[i])));
                  }
                }
              }
              this.$data.productSalesMerchants.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })
            },
          addProductSalesMerchant: function(m) {
            let found = false;
            if(this.$data.productSalesMerchants.length > 0) {
              for (let i = 0; i < this.$data.statementMerchants.length; i++) {
                if(this.$data.productSalesMerchants[i].id == m.id) {
                  found = true;
                  return;
                }
              }
            }
            this.$data.productSalesMerchants.push(JSON.parse(JSON.stringify(m)));
            this.$data.productSalesMerchants.sort(function(a, b) {
              return a.title > b.title ? 1 : -1;
            })

          },
            addStatementMerchant: function(m) {
              let found = false;
              if(this.$data.statementMerchants.length > 0) {
                for (let i = 0; i < this.$data.statementMerchants.length; i++) {
                  if(this.$data.statementMerchants[i].id == m.id) {
                    found = true;
                    return;
                  }
                }
              }
              this.$data.statementMerchants.push(JSON.parse(JSON.stringify(m)));
              this.$data.statementMerchants.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })

            },
            getSales: function() {
              let start = new Date(this.$data.filter.dateFrom);
              start.setHours(0,0,0,0);
              let end = new Date(this.$data.filter.dateTo);
              end.setHours(23,59,59,999);

              let query = "merchantId=" + this.$data.selectedMerchantId;
              query += "&stateFrom=100&stateTo=100";
              query += "&deliveryFrom=" + this.$data.filter.dateFrom + "&deliveryTo=" + this.$data.filter.dateTo;

              this.initialiseList();
              let self = this;
              queryOrders(query)
              .then(function(data) {
                if(data.success == true) {
                  self.$data.sales = data.item;
                  self.generateSalesSummary();

                } else {

                }
              })
              .catch(function(err) {
                console.log(err);
              })
            },
            downloadSalesReport: function() {
              let query = "merchantId=0";
              query += "&stateFrom=100&stateTo=100";
              query += "&deliveryFrom=" + this.$data.filter.dateFrom + "&deliveryTo=" + this.$data.filter.dateTo;
              let self = this;
              const FileDownload = require('js-file-download');
              getOrderReport(query)
              .then(function(response) {
                FileDownload(response.data, "Kokoro-Sales-" + self.$data.filter.dateFrom + "-" + self.$data.filter.dateTo + "-report.xlsx");
              })
              .catch(function(err) {
                console.log("report error " + err);
                if(err.response != undefined) {
                  console.log(err.response);
                }
              })
            },
            generateSalesSummary: function() {
              this.$data.salesSummary = {
                total:0,
                tax:0,
                due:0,
                paid:0,
                count:0,
                merchants:JSON.parse(JSON.stringify(this.$data.merchants))
              };

              for(let i = 0 ; i < this.$data.salesSummary.merchants.length ; i++) {
                this.$data.salesSummary.merchants[i].total = 0;
                this.$data.salesSummary.merchants[i].tax = 0;
                this.$data.salesSummary.merchants[i].due = 0;
                this.$data.salesSummary.merchants[i].paid = 0;
                this.$data.salesSummary.merchants[i].count = 0;
              }
              for(let i = 0 ; i < this.$data.sales.length ; i++) {
                this.$data.salesSummary.total += this.$data.sales[i].totalPrice;
                this.$data.salesSummary.tax += this.$data.sales[i].tax;
                this.$data.salesSummary.due += this.$data.sales[i].finalDue;
                this.$data.salesSummary.paid += this.$data.sales[i].paid;
                this.$data.salesSummary.count += 1;

                for(let j = 0 ; j < this.$data.salesSummary.merchants.length ; j++) {
                  console.log("Sales");
                  console.log(this.$data.sales[i]);
                  if(this.$data.sales[i].merchantId == this.$data.salesSummary.merchants[j].id) {
                    if(this.$data.salesSummary.merchants[j].total === undefined) {
                      this.$data.salesSummary.merchants[j].total = 0;
                    }
                    if(this.$data.salesSummary.merchants[j].tax === undefined) {
                      this.$data.salesSummary.merchants[j].tax = 0;
                    }
                    if(this.$data.salesSummary.merchants[j].due === undefined) {
                      this.$data.salesSummary.merchants[j].due = 0;
                    }
                    if(this.$data.salesSummary.merchants[j].paid === undefined) {
                      this.$data.salesSummary.merchants[j].paid = 0;
                    }

                    this.$data.salesSummary.merchants[j].total += this.$data.sales[i].totalPrice;
                    this.$data.salesSummary.merchants[j].tax += this.$data.sales[i].tax;
                    this.$data.salesSummary.merchants[j].due += this.$data.sales[i].finalDue;
                    this.$data.salesSummary.merchants[j].paid += this.$data.sales[i].paid;
                    this.$data.salesSummary.merchants[j].count += 1;
                    break;
                  }
                }
              }
              console.log("Sales Summary")
              console.log(this.$data.salesSummary);
            },
            getStockIns: function() {
              this.$data.sales = [];
              this.$data.stocks = [];
              let start = new Date(this.$data.filter.dateFrom);
              start.setHours(0,0,0,0);
              let end = new Date(this.$data.filter.dateTo);
              end.setHours(23,59,59,999);
              let query = "type=stock_in";
              query += "&timeFrom=" + start.getTime() + "&timeTo=" + end.getTime();

              this.initialiseList();
              let self = this;
              stockQuery(query)
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.stocks = data.list;
                    self.generateStockSummary();
                  } else {

                  }
                })
                .catch(function(err) {

                })
            },
            generateStockSummary: function() {
              this.$data.stockSummary = {
                total:0,
                tax:0,
                due:0,
                count:0,
                vendors:[],
              };

              for(let i = 0 ; i < this.$data.vendors.length ; i++) {

                this.$data.stockSummary.vendors.push(JSON.parse(JSON.stringify(this.$data.vendors[i])));
              }
              for(let i = 0 ; i < this.$data.suppliers.length ; i++) {

                this.$data.stockSummary.vendors.push(JSON.parse(JSON.stringify(this.$data.suppliers[i])));
              }
              for(let i = 0 ; i < this.$data.stockSummary.vendors.length ; i++) {
                this.$data.stockSummary.vendors[i].total = 0;
                this.$data.stockSummary.vendors[i].tax = 0;
                this.$data.stockSummary.vendors[i].due = 0;
                this.$data.stockSummary.vendors[i].count = 0;
              }
              for(let i = 0 ; i < this.$data.stocks.length ; i++) {
                this.$data.stockSummary.total += this.$data.stocks[i].totalPrice;
                this.$data.stockSummary.tax += this.$data.stocks[i].tax;
                this.$data.stockSummary.due += this.$data.stocks[i].finalDue;
                this.$data.stockSummary.count += 1;

                for(let j = 0 ; j < this.$data.stockSummary.vendors.length ; j++) {
                  if(this.$data.stocks[i].vendorId == this.$data.stockSummary.vendors[j].id) {


                    this.$data.stockSummary.vendors[j].total += this.$data.stocks[i].totalPrice;
                    this.$data.stockSummary.vendors[j].tax += this.$data.stocks[i].tax;
                    this.$data.stockSummary.vendors[j].due += this.$data.stocks[i].finalDue;
                    this.$data.stockSummary.vendors[j].count += 1;
                    break;
                  }
                }
              }
            },
            getPurchaseOrders: function() {
              let start = new Date(this.$data.filter.dateFrom);
              start.setHours(0,0,0,0);
              let end = new Date(this.$data.filter.dateTo);
              end.setHours(23,59,59,999);
              let query = "stateFrom=100&stateTo=100";
              query += "&sentFrom=" + start.getTime() + "&sentTo=" + end.getTime();

              this.initialiseList();
              let self = this;
              getVendorOrders(query)
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.purchaseOrders = data.item;
                    self.generatePOSummary();
                  } else {

                  }
                })
                .catch(function(err) {

                })
            },
            generatePOSummary: function() {
              this.$data.purchaseOrderSummary = {
                total:0,
                tax:0,
                due:0,
                count:0,
                vendors:[],
              };

              for(let i = 0 ; i < this.$data.vendors.length ; i++) {

                this.$data.purchaseOrderSummary.vendors.push(JSON.parse(JSON.stringify(this.$data.vendors[i])));
              }
              // for(let i = 0 ; i < this.$data.suppliers.length ; i++) {
              //
              //   this.$data.stockSummary.vendors.push(JSON.parse(JSON.stringify(this.$data.suppliers[i])));
              // }
              for(let i = 0 ; i < this.$data.purchaseOrderSummary.vendors.length ; i++) {
                this.$data.purchaseOrderSummary.vendors[i].total = 0;
                this.$data.purchaseOrderSummary.vendors[i].tax = 0;
                this.$data.purchaseOrderSummary.vendors[i].due = 0;
                this.$data.purchaseOrderSummary.vendors[i].count = 0;
              }
              for(let i = 0 ; i < this.$data.purchaseOrders.length ; i++) {
                this.$data.purchaseOrderSummary.total += this.$data.purchaseOrders[i].totalPrice;
                this.$data.purchaseOrderSummary.tax += this.$data.purchaseOrders[i].tax;
                this.$data.purchaseOrderSummary.due += this.$data.purchaseOrders[i].finalDue;
                this.$data.purchaseOrderSummary.count += 1;

                for(let j = 0 ; j < this.$data.purchaseOrderSummary.vendors.length ; j++) {
                  if(this.$data.purchaseOrders[i].vendorId == this.$data.purchaseOrderSummary.vendors[j].id) {


                    this.$data.purchaseOrderSummary.vendors[j].total += this.$data.purchaseOrders[i].totalPrice;
                    this.$data.purchaseOrderSummary.vendors[j].tax += this.$data.purchaseOrders[i].tax;
                    this.$data.purchaseOrderSummary.vendors[j].due += this.$data.purchaseOrders[i].finalDue;
                    this.$data.purchaseOrderSummary.vendors[j].count += 1;
                    break;
                  }
                }
              }
            },
            openInvoice: function(sale) {
              let url = 'https://storage.googleapis.com/kokoro-294123.appspot.com/' + sale.imageUrls[sale.imageUrls.length -1];
              window.open(url, '_blank');
            },
            openInvoiceView: function(order) {

              // this.$data.invoiceView = false;
              this.$data.invoiceView = order;
            },
            closeInvoiceView: function() {
              this.$data.invoiceView = false;
            },
            backgroundClick: function() {
              this.$data.candidates = [];
            },
            dateRangeSelected: function() {
              console.log("dateRangeSelected")
              console.log(this.$data.dateRange)

              if(this.$data.dateRange.length !== 2) {
                return;
              }

              if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
                let temp = this.$data.dateRange[1];
                this.$data.dateRange[0] = this.$data.dateRange[1];
                this.$data.dateRange[1] = temp;
              }

            },
            performanceDateRangeSelected: function() {
              if(this.$data.performanceDateRange.length !== 2) {
                return;
              }

              if(this.$data.performanceDateRange[0] > this.$data.performanceDateRange[1]) {
                let temp = this.$data.performanceDateRange[1];
                this.$data.performanceDateRange[0] = this.$data.performanceDateRange[1];
                this.$data.performanceDateRange[1] = temp;
              }
            },
            stockReportDateRangeSelected: function() {
              if(this.$data.stockReportDateRange.length !== 2) {
                return;
              }

              if(this.$data.stockReportDateRange[0] > this.$data.stockReportDateRange[1]) {
                let temp = this.$data.stockReportDateRange[1];
                this.$data.stockReportDateRange[0] = this.$data.stockReportDateRange[1];
                this.$data.stockReportDateRange[1] = temp;
              }
            },
            moveFocusOnCandidate: function(e, c) {
              const activeEle = e.target;
              // const activeEleIndex = Array.prototype.indexOf.call(activeEle.parentElement, activeEle);
              console.log(e);
              console.log(c);
              // console.log("index " + activeEleIndex);
              console.log(e.key);
              if(e.key == "ArrowDown" && activeEle.nextElementSibling != null) {
                console.log("move down");
                activeEle.nextElementSibling.focus();
              }

              if(e.key == "ArrowUp")
                if(activeEle.previousElementSibling != null) {
                  console.log("move up");
                  activeEle.previousElementSibling.focus();
                } else {
                  document.getElementById("product-candidate-search-input").focus();
              }

              if(e.key == 'Enter') {

                if(activeEle.nextElementSibling != null) {
                  activeEle.nextElementSibling.focus();
                } else if(activeEle.previousElementSibling != null) {
                  activeEle.previousElementSibling.focus();
                }
                this.selectCandidate(c);
              }
            },
            search: function(e){

              console.log(e);
              if(e.key == 'ArrowDown') {
                console.log('ArrowDown');
                let firstCandidate = document.getElementById('product-candidate-0');
                if(firstCandidate != undefined && firstCandidate != null) {
                  firstCandidate.focus();
                } else {
                  console.log("cannot find ele");
                }
                return;
              }
              let self = this;
              this.$data.selectedProductId = 0;
              console.log("Search " + this.$data.productSearchWord);
              if(this.$data.productSearchWord == null || this.$data.productSearchWord.length < 3) {
                this.$data.candidates = [];
                return;
              }


              searchAllProducts(this.$data.productSearchWord)
                .then(function(data) {
                  console.log("search result ");
                  console.log(data);
                  if(data.success == true) {
                    self.$data.candidates =  data.item;
                  } else {
                    self.$data.candidates = [];
                  }
                })
                .catch(function(err) {
                  self.$data.candidates = [];
                })
              // return new Promise((resolve) => {
              //   if(input.length < 3) {
              //     resolve([]);
              //   }
              //   // self.searchProduct(encodeURI(input), resolve);
              //
              // })

            },
            initialiseSearch: function() {
              this.$data.productSearchWord = '';
              this.$data.candidates = [];
            },
            isOnSelectedProductList: function(p) {
              if(this.$data.selectedProducts.length == 0) {
                return false;
              }

              for(let i = 0 ; i < this.$data.selectedProducts.length ; i++) {
                if(this.$data.selectedProducts[i].id == p.id) {
                  return true;
                }
              }
              return false;
            },
            categorySelected: function() {
              if(this.$data.selectedCat == 0) {
                this.$data.candidates = [];
                return;
              }
              let self = this;
              getProductsByCategory(this.$data.selectedCat, 'all')
              .then(function(data) {
                if(data.success == true) {
                  self.$data.candidates = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })

            },
            addAllCandidate: function() {
              for(let i = 0 ; i < this.$data.candidates.length ; i++) {
                if(this.isOnSelectedProductList(this.$data.candidates[i]) == true) {
                  continue;
                }
                this.$data.selectedProducts.push(JSON.parse(JSON.stringify(this.$data.candidates[i])));
              }
            },
            clearAllSelectedProducts: function() {
              this.$data.selectedProducts = [];
            },
            selectCandidate: function(candidate) {
              // this.$data.productSearchWord = '';
              // this.$data.selectedProductId = candidate.id;
              // this.$data.candidates = [];

              if(this.isOnSelectedProductList(candidate) == true) {
                return;
              }
              this.$data.selectedProducts.push(JSON.parse(JSON.stringify(candidate)));

              this.$data.selectedProducts.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })
              console.log("selected products " + this.$data.selectedProducts.length);
            },
            selectProductReport: function(p) {
              this.$data.selectedProductReport = false;
              let self = this;
              setTimeout( function() {
                self.$data.selectedProductReport = JSON.parse(JSON.stringify(p));
              }, 300)

            },
            downloadSummaryStatementItemReport: function() {
              if(this.$data.itemReports == false) {
                return;
              }
              let self = this;
              let reports = JSON.parse(JSON.stringify(this.$data.itemReports));

              for(let i = 0 ; i < reports.list.length ; i++) {
                reports.list[i].list = [];
              }
              getOrderItemSummaryPDF(reports)
                .then(function (data) {
                  if (data.success == true) {
                    self.$data.itemReports.filePath = data.message;
                    self.$data.statementPdfView = self.$data.itemReports;
                  } else {
                    showDialog(data.message);
                  }
                })
            },
            downloadStatementItemReport: function(type = 'pdf') {
              if(this.$data.itemReports == false) {
                return;
              }
              let self = this;
              if(type == 'pdf') {
                getOrderItemSummaryPDF(this.$data.itemReports)
                  .then(function (data) {
                    if (data.success == true) {
                      self.$data.itemReports.filePath = data.message;
                      self.$data.statementPdfView = self.$data.itemReports;
                    } else {
                      showDialog(data.message);
                    }
                  })
              } else if(type == 'xlsx') {
                const FileDownload = require('js-file-download');
                let fileName = this.$data.itemReports.dateFrom + "-" + this.$data.itemReports.dateTo + "-item-summary.xlsx";
                getOrderItemSummaryExcel(this.$data.itemReports)
                  .then(function (response) {
                    console.log(response);
                    FileDownload(response.data, fileName);

                  })
                  .catch(function (err) {
                    showDialog("Faield to generate Excel", "ERROR");
                  })
              }

            },
            getStatementItemReport: function() {

              this.$data.itemReports = false;
              this.$data.selectedProductReport = false;
              if(this.$data.dateRange == null) {
                showDialog("Please select date range");
                return;
              }
              if(this.$data.dateRange.length !== 2) {
                return;
              }

              // if(this.$data.statementMerchantId == 0) {
              //   showDialog("Select Shop to get statement");
              //   return;
              // }
              if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
                let temp = this.$data.dateRange[1];
                this.$data.dateRange[0] = this.$data.dateRange[1];
                this.$data.dateRange[1] = temp;
              }

              // let from = new Date(this.$data.dateRange[0]);
              // from.setHours(0);
              // from.setMinutes(0);
              // from.setSeconds(0);
              // from.setMilliseconds(0);
              //
              // let to = new Date(this.$data.dateRange[1]);
              // to.setHours(23);
              // to.setMinutes(59);
              // to.setSeconds(59);
              // to.setMilliseconds(999);

              let query = 'merchantId='+this.$data.statementMerchantId + "&dateFrom="+this.$data.dateRange[0] + "&dateTo=" + this.$data.dateRange[1];

              let mIds = [];
              if(this.$data.productSalesMerchants !== null && this.$data.productSalesMerchants.length > 0) {
                for(let i = 0 ; i < this.$data.productSalesMerchants.length ; i++) {
                  mIds.push(this.$data.productSalesMerchants[i].id);
                }
              }

              if(mIds.length > 0) {
                query += "&merchantIds=" + mIds.join(",");
              }

              let self = this;
              self.$data.statementProductItems = [];
              let pIds = [];

              for(let i = 0 ; i < this.$data.selectedProducts.length ; i++) {
                pIds.push(this.$data.selectedProducts[i].id);
                this.$data.selectedProducts[i].merchants = JSON.parse(JSON.stringify(this.$data.merchants));
              }

              query += "&productIds=" + pIds.join(",");
              console.log(query);
              queryOrderItemStatement(query)
                .then(function(data) {
                  if(data.success == true) {
                    console.log("report response");
                    console.log(data);
                    self.$data.itemReports = data.item;
                    // self.populateItemReport(data.item);
                    // self.addStatementSummary();
                  } else {
                    showDialog(data.message);
                  }
                })
                .catch(function(err) {
                  console.log(err);
                  if(err.response != undefined) {
                    console.log(err.response);
                  }
                })
            },
            populateItemReport: function(list) {

              let products = JSON.parse(JSON.stringify(this.$data.selectedProducts));
              for(let p = 0 ; p < products.length ; p++) {
                let merchants = JSON.parse(JSON.stringify(this.$data.merchants));
                for(let i = 0 ; i < merchants.length ; i++) {
                  merchants[i].orderedAmount = 0;
                  merchants[i].amount = 0;
                  merchants[i].net = 0;
                  merchants[i].vat = 0;
                  merchants[i].gross = 0;
                  merchants[i].list = [];
                  merchants[i].dates = this.$data.dateRange[0] + "-" + this.$data.dateRange[1];


                }
                products[p].merchants = merchants;
                products[p].amount = 0;
                products[p].net = 0;
                products[p].vat = 0;
                products[p].gross = 0;

              }

              for(let i = 0 ; i < list.length ; i++) {
                for(let p = 0 ; p < products.length ; p++) {
                  if(products[p].id === list[i].productId) {
                    for (let j = 0; j < products[p].merchants.length; j++) {
                      if (products[p].merchants[j].id == list[i].merchantId) {
                        products[p].merchants[j].orderedAmount += list[i].orderedAmount;
                        products[p].merchants[j].amount += list[i].amount;
                        products[p].merchants[j].net += list[i].totalPrice;
                        products[p].merchants[j].vat += list[i].tax;
                        products[p].merchants[j].gross += list[i].finalDue;
                        products[p].merchants[j].list.push(list[i]);

                        products[p].amount += list[i].amount;
                        products[p].net += list[i].totalPrice;
                        products[p].vat += list[i].tax;
                        products[p].gross += list[i].finalDue;
                        // this.$data.selectedProducts[p].merchants[j].list.push(list[i]);
                        break;
                      }
                    }
                    break;
                  }
                }
              }
              this.$data.itemReports = products;
              console.log("Report");
              console.log(this.$data.itemReports);

              // this.$data.statementProductItems = merchants;
            },
            isOnPerformanceMerchantsList: function(m) {
              for (let i = 0; i < this.$data.performanceMerchants.length; i++) {
                if(this.$data.performanceMerchants[i].id == m.id) {
                  return true;
                }
              }
              return false;
            },
            selectPerformanceMerchantByType: function(type) {
              // this.$data.statementMerchants = [];
              for (let i = 0; i < this.$data.merchants.length; i++) {
                if(type === 'all' || this.$data.merchants[i].type === type) {
                  let foundFromSelectedList = false;
                  for(let m = 0 ; m < this.$data.performanceMerchants.length ; m++) {
                    if(this.$data.performanceMerchants[m].id == this.$data.merchants[i].id) {
                      foundFromSelectedList = true;
                      break;
                    }
                  }
                  if(foundFromSelectedList == false) {
                    this.$data.performanceMerchants.push(JSON.parse(JSON.stringify(this.$data.merchants[i])));
                  }
                }
              }
              this.$data.performanceMerchants.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })
            },
            addPerformanceMerchant: function(m) {
              let found = false;
              if(this.$data.performanceMerchants.length > 0) {
                for (let i = 0; i < this.$data.performanceMerchants.length; i++) {
                  if(this.$data.performanceMerchants[i].id == m.id) {
                    found = true;
                    return;
                  }
                }
              }
              this.$data.performanceMerchants.push(JSON.parse(JSON.stringify(m)));
              this.$data.performanceMerchants.sort(function(a, b) {
                return a.title > b.title ? 1 : -1;
              })

            },
            getPerformance: function() {
              this.$data.performanceReportFilter = '';
              if(this.$data.performanceDateRange == null || this.$data.performanceDateRange.length !== 2) {
                showDialog("Select Date Range");
                return;
              }
              if(this.$data.performanceMerhantId == 0) {
                showDialog("Select Shop");
                return;
              }
              if(this.$data.performanceDateRange[0] > this.$data.performanceDateRange[1]) {
                let temp = this.$data.performanceDateRange[1];
                this.$data.performanceDateRange[0] = this.$data.performanceDateRange[1];
                this.$data.performanceDateRange[1] = temp;
              }
              let ids = [];
              for(let i = 0 ; i < this.$data.performanceMerchants.length ; i++) {
                ids.push(this.$data.performanceMerchants[i].id);
              }
              if(ids.length == 0) {
                showDialog("Please select shops");
                return;
              }
              let query = "merchantIds=" + ids.join(',') + "&dateFrom="+this.$data.performanceDateRange[0] + "&dateTo=" + this.$data.performanceDateRange[1];

              let self = this;
              queryMerchantPerformance(query)
              .then(function(data) {
                if(data.success == true) {
                  console.log(data.item);
                  // data.item.list.sort(function(a,b) {
                  //   if(a.title < b.title) {
                  //     return -1;
                  //   } else if(a.title > b.title) {
                  //     return 1;
                  //   }
                  //   return 0;
                  // })
                  self.$data.performanceReport = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
            },
            exportPerformance: function(type, showBreakdown) {
              if(this.$data.performancceReport == false) {
                showDialog("리포트가 없습니다.");
                return;
              }
              const FileDownload = require('js-file-download');
              let fileName = '매장매출분석-' + this.$data.performanceReport.dateFrom + "-" + this.$data.performanceReport.dateTo + "-item-summary-";
              if(showBreakdown == true) {
                fileName += "FULL";
              }
              fileName += "-" + generateOrderNumber() + ".xlsx";
              getPerformanceStatementExcel(this.$data.performanceReport, showBreakdown)
              .then(function(response) {
                FileDownload(response.data, fileName);
              })
              .catch(function(err) {

              })
            },
            getStatementReport: function() {
              if(this.$data.dateRange == null || this.$data.dateRange.length !== 2) {
                showDialog("Select Date Range");
                return;
              }

              if(this.$data.statementMerchants.length == 0) {
                showDialog("Select Shop to get statement");
                return;
              }
              if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
                let temp = this.$data.dateRange[1];
                this.$data.dateRange[0] = this.$data.dateRange[1];
                this.$data.dateRange[1] = temp;
              }

              if(this.$data.statementMerchants == null || this.$data.statementMerchants.length == 0) {
                showDialog("Please Select Shops");
                return;
              }

              let query = "&from="+this.$data.dateRange[0] + "&to=" + this.$data.dateRange[1] + "&payment=" + this.$data.statementPayment;

              let mids = [];
              for(let i = 0 ; i < this.$data.statementMerchants.length ; i++) {
                mids.push(this.$data.statementMerchants[i].id);
              }

              query += "&merchantIds=" + mids.join(',');

              let self = this;
              self.$data.statementItems = [];
              queryOrderStatement(query)
              .then(function(data) {
                if(data.success == true) {
                  data.item.list.sort(function(a, b) {
                    return a.title > b.title ? 1: -1;
                  })
                  console.log(data.item);
                  self.$data.statementReport = data.item;
                  // self.$data.selectedProducts = data.item;
                  // self.$data.statementItems = data.item;
                  // self.addStatementSummary();
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {

              })
            },
            // addStatementSummary: function() {
            //   let totalNet = 0;
            //   let totalVat = 0;
            //   let totalGross = 0;
            //   let totalPaid = 0;
            //
            //   for(let i = 0 ; i < this.$data.statementItems.length ; i++) {
            //     if(this.$data.statementItems[i].orderType === 'sales') {
            //       totalNet += this.$data.statementItems[i].totalPrice;
            //       totalVat += this.$data.statementItems[i].tax;
            //       totalGross += this.$data.statementItems[i].finalDue;
            //       totalPaid += this.$data.statementItems[i].paid;
            //     } else if(this.$data.statementItems[i].orderType == 'credit') {
            //       totalNet -= this.$data.statementItems[i].totalPrice;
            //       totalVat -= this.$data.statementItems[i].tax;
            //       totalGross -= this.$data.statementItems[i].finalDue;
            //     }
            //   }
            //
            //   let totalItem = {
            //     type: 'summary',
            //     deliveredDate:'',
            //     totalPrice:totalNet,
            //     tax:totalVat,
            //     finalDue:totalGross,
            //     paid:totalPaid,
            //     invoice:null,
            //
            //   }
            //
            //   this.$data.statementItems.push(totalItem)
            // },
            downloadSelectedMerchantStatement: function(merchant, type) {
              if(this.$data.dateRange.length !== 2) {
                return;
              }
              // if(this.$data.statementMerchantId == 0) {
              //   showDialog("Select Shop to get statement");
              //   return;
              // }
              if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
                let temp = this.$data.dateRange[1];
                this.$data.dateRange[0] = this.$data.dateRange[1];
                this.$data.dateRange[1] = temp;
              }

              let query = "from="+this.$data.dateRange[0] + "&to=" + this.$data.dateRange[1];

              let self = this;

              if(type === 'pdf') {
                let report = {
                  title: this.$data.statementReport.title,
                  dateFrom: this.$data.statementReport.dateFrom,
                  dateTo:this.$data.statementReport.dateTo,
                  filePath:'',
                  totalPrice:merchant.totalPrice,
                  tax:merchant.tax,
                  finalDue:merchant.finalDue,
                  paid:merchant.paid,
                  list:[merchant],
                }
                // let merchants = [merchant];
                let showCost = false;
                if(this.$data.mode === 'profit') {
                  showCost = true;
                }
                getOrderStatementPDF(report, showCost, false)
                  .then(function(data) {
                    if(data.success == true) {
                      merchant.filePath = data.message;
                      self.$data.statementPdfView = merchant;
                    } else {
                      showDialog(data.message);
                    }
                  })
                  .catch(function(err) {
                    let msg = err;
                    if(err.response != undefined) {
                      msg += ' (' + err.response + ')';
                    }
                    showDialog(msg, "ERROR");
                  })
              }
            },
            downloadStatement: function(type, summary = false) {


              if(this.$data.statementReport == false) {
                return;
              }
              let showCost = false;
              if(this.$data.mode === 'profit') {
                showCost = true;
              }
              let self = this;
              if(type === 'xlsx') {
                const FileDownload = require('js-file-download');
                let fileName = this.$data.statementReport.dateFrom + "-" + this.$data.statementReport.dateTo + "-Statement.xlsx";

                getOrderStatementExcel(this.$data.statementReport, showCost)
                  .then(function (response) {
                    console.log(response);
                    FileDownload(response.data, fileName);

                  })
                  .catch(function (err) {
                    showDialog("Faield to generate Excel", "ERROR");
                  })
              } else if(type === 'pdf') {
                getOrderStatementPDF(this.$data.statementReport, showCost, summary)
                .then(function(data) {
                  if(data.success == true) {
                    self.$data.statementReport.filePath = data.message;
                    self.$data.statementPdfView = self.$data.statementReport;
                  } else {
                    showDialog(data.message);
                  }
                })
                .catch(function(err) {
                  let msg = err;
                  if(err.response != undefined) {
                    msg += ' (' + err.response + ')';
                  }
                  showDialog(msg, "ERROR");
                })
              }
            },
            sendStatementDocument: function(statement) {

              // to.setMilliseconds(999);

              let query = 'merchantId='+statement.merchant.id + "&from="+statement.dateFrom + "&to=" + statement.dateTo;
              query += "&path=" + statement.filePath;

              let self = this;

              sendOrderStatementPDF(query)
              .then(function(data) {
                if(data.success == true) {
                  showDialog("Statement sent successfully");
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
            },
            getAssetReport: function() {
              let self = this;
              self.$data.assetReport = false;
              assetStatement()
              .then(function(data) {
                if(data.success == true) {
                  self.$data.assetReport = data.item;
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {
                let msg = err;
                if(err.response != undefined) {
                  msg += ' (' + err.response + ')';
                }
                showDialog(msg, "ERROR");
              })
            },
            downloadAssetStatement: function(type) {
              if(this.$data.assetReport == false) {
                return;
              }
              let self = this;
              if(type === 'xlsx') {
                const FileDownload = require('js-file-download');
                let fileName = this.$data.assetReport.dateFrom + "-Asset-Statement.xlsx";
                assetStatementExcel(this.$data.assetReport)
                  .then(function (response) {
                    console.log(response);
                    FileDownload(response.data, fileName);

                  })
                  .catch(function (err) {
                    showDialog("Faield to generate Excel", "ERROR");
                  })
              } else if(type === 'pdf') {
                assetStatementPDF(this.$data.assetReport)
                  .then(function(data) {
                    if(data.success == true) {
                      self.$data.assetReport.filePath = data.message;
                      self.$data.statementPdfView = self.$data.assetReport;
                    } else {
                      showDialog(data.message);
                    }
                  })
                  .catch(function(err) {
                    let msg = err;
                    if(err.response != undefined) {
                      msg += ' (' + err.response + ')';
                    }
                    showDialog(msg, "ERROR");
                  })
              }
            },
            getStockReports: function() {
              if(this.$data.stockReportDateRange === null  || this.$data.stockReportDateRange.length !== 2) {
                showDialog("Please select date range");
                return;
              }
              let self = this;

              getDocuments('stock_report', this.$data.stockReportDateRange[0], this.$data.stockReportDateRange[1])
                .then(function(data) {
                  if(data.success === true) {
                    self.$data.stockReports = data.item;
                  } else {
                    showDialog(data.message);
                  }
                })
                .catch(function(err) {
                  let msg = err;
                  if(err.response != undefined) {
                    msg += ' (' + err.response + ')';
                  }
                  showDialog(msg, "ERROR");
                })
            },
            downloadStockReport: function(report) {
              window.open(report.url, '_blank');
            },
            getStockAssetReport: function(type) {
              let self = this;
              if(type === 'xlsx') {
                const FileDownload = require('js-file-download');
                let today = millisToDate(new Date().getTime(), '-');
                let fileName = today + "-STOCK-VALUE-REPORT.xlsx";
                stockValueReportExcel()
                .then(function (response) {
                  console.log(response);
                  FileDownload(response.data, fileName);

                })
                .catch(function (err) {
                  showDialog("Faield to generate Excel", "ERROR");
                })
              }
            },
            thousandSeprator: function(amount) {
              if (amount !== '' || amount !== undefined || amount !== 0  || amount !== '0' || amount !== null) {
                return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return amount;
              }
            },
        }
    }
</script>

<style scoped>

  .sales-row {
    background-color: #f3f3f3;
  }
  .credit-row {
    background-color: #FFDADA;
  }
  .mx-datepicker-range {
    width: 250px;
  }
  .sticky-header-row > th {
    position: sticky;
    top:0;
  }
  .sticky-bottom-row > td {
    position: sticky;
    bottom:0;
    background-color: #D7D7D7;
  }
  /*.table-section-divider > td{*/
  /*  border-top: 1px solid black;*/
  /*}*/
  .section tbody{
    display:block;
    border: 2px solid black;
    border-collapse: collapse;
    border-spacing: 4px;
  }
  .section-0 > td{
    background-color: #F9EBEA;
  }
  .section-1 > td{
    background-color: #F5EEF8;
  }
  .section-2 > td{
    background-color: #EAF2F8;
  }
  .section-3 > td{
    background-color: #E8F8F5;
  }
  .section-4 > td{
    background-color: #FEF9E7;
  }

  .left-section-border {
    border-left:1px solid black;
  }
  .deactivated {
    background-color: #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/Report.vue